import script from "./CategoryItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryItem.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryItem.vue?vue&type=style&index=0&id=337d0b7d&lang=css"

const __exports__ = script;

export default __exports__